"use client"

import { useEffect } from "react"

interface StatisticsTrackerProps {
  nid: string
}

export default function StatisticsTracker({ nid }: StatisticsTrackerProps) {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Use local backend URL in development, CDN route in production
        const statisticsUrl =
          process.env.NODE_ENV === "development"
            ? "http://localhost:8889/modules/contrib/statistics/statistics.php"
            : "/statistics.php"

        await fetch(statisticsUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `nid=${encodeURIComponent(nid)}`,
        })
      } catch (error) {
        // Silently fail - statistics tracking should not affect user experience
        console.debug("Statistics tracking failed:", error)
      }
    }

    void trackPageView()
  }, [nid])

  // This component renders nothing - it's purely for side effects
  return null
}
